<template>
    <div class="main-layout__container">
        <div class="content__header">
            <div class="content-header__title">
                Документы
            </div>
            <div class="content-header__background"></div>
        </div>

        <div class="content__body">
            <div class="legal-page">
                <div class="documents-list__list">
                    <div v-for="document in documents" class="document-item">
                        <div class="document-item__title">{{ document.title }}</div>

                        <a
                            :href="document.link"
                            class="document-item__link"
                            target="_blank"
                        >
                            <img v-svg-inline src="@/assets/icons/arrowGoLink.svg" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import PersonalDataProcessDoc from '@/documents/legal/pravila-obrabotki-personalnih-dannih.pdf';
    import PersonalDataPolicyDoc from '@/documents/legal/politika-v-oblasti-obrabotki-personalnih-dannih.pdf';
    import UserAgreementDoc from '@/documents/legal/polzovatelskoe-soglashenie-ob-ispolzovanii-servisa-hyundai-id.pdf';
    import PrivacyPolicyDoc from '@/documents/legal/politika-konfidencialnosty.pdf';

    const documents = [
        {
            title: 'Правила обработки персональных данных',
            link: PersonalDataProcessDoc,
        },
        {
            title: 'Политика в области обработки персональных данных',
            link: PersonalDataPolicyDoc,
        },
        {
            title: 'Пользовательское соглашение об использовании сервиса «Hyundai ID»',
            link: UserAgreementDoc,
        },
        {
            title: 'Политика конфиденциальности',
            link: PrivacyPolicyDoc,
        },
    ];
</script>

<style scoped lang="scss">
    @use './ViewLegal.scss' as *;
</style>
